import {useRegisterSW} from "virtual:pwa-register/react";
import BaseModal from "@components/BaseModal";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import useNeedsProfileOnboarding from "@/hooks/useNeedsProfileOnboarding";
import {useBrandTitle} from "../../../util/logoUtils";

const intervalMS = 60 * 60 * 1000;

const UpdatePrompt = () => {
  const brandTitle = useBrandTitle();
  const {needsOnboarding, isLoading: isOnboardingLoading} = useNeedsProfileOnboarding();

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(swUrl, r) {
      if (!r) {
        return;
      }

      const checkForUpdate = async () => {
        if (r.installing || !navigator) {
          return;
        }

        if ("connection" in navigator && !navigator.onLine) {
          return;
        }

        try {
          const resp = await fetch(swUrl, {
            cache: "no-store",
            headers: {
              cache: "no-store",
              "cache-control": "no-cache",
            },
          });

          if (resp?.status === 200) {
            await r.update();
          }
        } catch (_err) {
          // Network errors are expected when offline; ignore.
        }
      };

      // Check immediately on register (covers PWA cold-start, especially on iOS
      // standalone where setInterval is killed when the app is suspended).
      checkForUpdate();

      // Check whenever the tab/PWA becomes visible again. iOS suspends JS
      // when the standalone PWA is backgrounded, so this is the most
      // reliable trigger for home-screen installs.
      if (typeof document !== "undefined") {
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            checkForUpdate();
          }
        });
      }

      setInterval(checkForUpdate, intervalMS);
    },
    onRegisterError(_error) {},
  });

  const handleUpdate = () => {
    updateServiceWorker(true);
    setNeedRefresh(false);
  };

  const handleCancel = () => {
    setNeedRefresh(false);
  };

  return (
    <BaseModal
      title="Actualización Disponible"
      open={needRefresh && !needsOnboarding && !isOnboardingLoading}
      footer={[
        <PrimaryButton
          key="update"
          onClick={() => handleUpdate()}
        >
          Actualizar Ahora
        </PrimaryButton>,
        <SecondaryButton
          key="cancel"
          onClick={() => handleCancel()}
        >
          Actualizar Luego
        </SecondaryButton>,
      ]}
    >
      <p style={{color: "var(--text-primary)"}}>
        Una nueva version de {brandTitle} esta disponible. Quieres actualizar ahora?
      </p>
    </BaseModal>
  );
};

export default UpdatePrompt;
